import { render } from "./InfoPage.vue?vue&type=template&id=449da264"
import script from "./InfoPage.vue?vue&type=script&lang=js"
export * from "./InfoPage.vue?vue&type=script&lang=js"
script.render = render

export default script